interface FileValidationOptions {
  accept?: string;
  maxSize?: number; // in bytes
}

interface FileValidationResult {
  valid: boolean;
  error?: string;
}

const formatBytes = (bytes: number) =>
  (bytes / (1024 * 1024)).toFixed(2) + "MB";

export function validateFile(
  file: File,
  { accept, maxSize }: FileValidationOptions = {},
): FileValidationResult {
  if (accept) {
    const acceptedTypes = accept.split(",").map((type) => type.trim());
    const isValidType = acceptedTypes.some((acceptedType) => {
      if (acceptedType.endsWith("/*")) {
        return file.type.startsWith(acceptedType.slice(0, -1));
      }
      return file.type === acceptedType;
    });

    if (!isValidType) {
      return {
        valid: false,
        error: `Invalid file type. Please select a file of type: ${accept}`,
      };
    }
  }

  if (maxSize && file.size > maxSize) {
    return {
      valid: false,
      error: `File too large. Please select a file smaller than ${formatBytes(maxSize)}`,
    };
  }

  return { valid: true };
}
